module.exports = __webpack_public_path__ + "img/tarj1-5.b0c9aec2.svg";